import React from 'react';
import styled from 'styled-components';
import { Card, CardContent, Icon } from '@material-ui/core';
import { PropsOnlyChildren } from '@domain/types/prop.types';

export const SpacedCard = styled(Card)`
  margin-bottom: 16px;
`;

export const ContentArea = ({ children, ...rest }: PropsOnlyChildren) => {
  return (
    <SpacedCard {...rest}>
      <CardContent>{children}</CardContent>
    </SpacedCard>
  );
};

export const TabContent = styled(ContentArea)`
  border-top-width: 0;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
  background-color: transparent;
`;

export const TabContainer = styled.div`
  background-color: #fff;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
`;

export const FloatClear = styled.div`
  clear: both;
`;

export const InlineIcon = styled(Icon)`
  vertical-align: middle;
  margin-top: -5px;
  margin-bottom: -3px;
`;

export const CenteredRoot = styled.div`
  text-align: center;
`;

export const DescText = styled.p`
  margin-top: 8px;
  margin-bottom: 24px;
`;
